import Connection from '../connection';

const BASE_PATH = '/invites';

export function loadInvites(userId) {
  return Connection.send(`${BASE_PATH}`, { userId });
}

export function generateInvite(userId) {
  const URL = '/generate';
  return Connection.send(`${BASE_PATH}${URL}`, { userId }, 'POST');
}

export function revokeInvite(userId, inviteId) {
  return Connection.send(`${BASE_PATH}/${inviteId}`, { userId }, 'DELETE');
}



// WEBPACK FOOTER //
// ./src/services/api/invites.js